import { css } from '@emotion/react'
import { mTheme } from '../../style/themes'

const { breakpoint, size, pageWidth } = mTheme

export const page: Style = css({
  display: 'grid',
  width: '100%',

  [breakpoint.medium]: {
    justifyContent: 'center',
  },
  [breakpoint.large]: {
    minWidth: pageWidth.L,
  },
})

export const headingContainer: Style = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  [breakpoint.medium]: {
    paddingLeft: 0,
  },
  [breakpoint.belowMedium]: {
    marginTop: size.XS,
  },
})

export const heading: Style = css({
  maxWidth: '100%',
  marginTop: 0,
  marginBottom: 0,
})

export const content: Style = css({
  display: 'grid',
  gap: size.S,
  padding: size.S,
  paddingTop: 0,
  width: '100%',
  [breakpoint.medium]: {
    width: pageWidth.M,
  },
})
